import { logCustomEvent } from './services/firebase';

const reportWebVitals = (onPerfEntry) => {
  // Always report to Firebase Analytics
  const sendToAnalytics = (metric) => {
    // Log to console in development
    if (process.env.NODE_ENV === 'development') {
      console.log(`📈 Web Vital: ${metric.name}`, {
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
      });
    }

    // Send to Firebase Analytics
    logCustomEvent('web_vitals', {
      metric_name: metric.name,
      metric_value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      metric_rating: metric.rating,
      metric_delta: Math.round(metric.delta),
      metric_id: metric.id,
    });
  };

  // Combine custom handler with analytics
  const handleMetric = (metric) => {
    sendToAnalytics(metric);
    if (onPerfEntry && onPerfEntry instanceof Function) {
      onPerfEntry(metric);
    }
  };

  import('web-vitals').then(({ onCLS, onFID, onFCP, onLCP, onTTFB, onINP }) => {
    onCLS(handleMetric);
    onFID(handleMetric);
    onFCP(handleMetric);
    onLCP(handleMetric);
    onTTFB(handleMetric);
    // INP (Interaction to Next Paint) - newer metric replacing FID
    if (onINP) {
      onINP(handleMetric);
    }
  });
};

export default reportWebVitals;
